const queryToString = (param: string | string[]) => {
  return typeof param === 'string' ? param : param[0];
};

export default queryToString;
